<app-user-nav (iniciarSesion)="abrirDialogoDeLogin()"></app-user-nav>



<!--  <app-command-bar ></app-command-bar>
 --><div class="docs-DialogExample-lgHeader" #dialogContainer>
  <div class="ms-Dialog ms-Dialog--lgHeader ms-Dialog-Login" appPreventOutsideClick>
    <div class="ms-Dialog-title">Ingreso BSP ADMIN</div>
    <form action="#" [formGroup]="loginForm" (ngSubmit)="onLogin()" name="loginForm">
      <div *ngIf="!ViewSSOLoginButton" >
        <div class="ms-Dialog-content">
          <app-text-box [frm]="loginForm" formControlName="UserName" type="email" [required]="true" label="Usuario"></app-text-box>
          <app-text-box [frm]="loginForm" formControlName="Password" type="password" [required]="false" label="Contraseña"></app-text-box>
          <small class="text-danger" style="color: brown;" *ngIf="loginForm.get('hasErrorInvalid')?.value">Usuario inactivo.</small>
          <small class="text-danger" style="color: brown;" *ngIf="loginForm.get('hasErrorPassword')?.value">Usuario o contraseña incorrectos.</small>
  
        </div>
        
        <app-form-buttons 
          [botonProcesando]="botonProcesando"
          buttonCancelId="btnCancel"
          labelCancel="Cancelar"
          buttonSaveId="btnSave"
          labelSave="Iniciar Sesión"
          [labelLoading]="textoBotonProcesando" 
          [frm]="loginForm">
        </app-form-buttons>
      </div>
      
      <div class="ms-Dialog-actions" *ngIf="ViewSSOLoginButton" [hidden]="botonProcesando">
        <!-- <em class="d-block text-muted small my-2 mr-2 mt-n2">─ o ─</em> -->
        <button class="ms-Button ms-Button--default" type="button" (click)="loginWithSSO()" [disabled]="botonProcesando">
          <span class="ms-Button-label">
            <i class="fa fa-lock mr-2"></i>
            {{ 'Ingresar con MFA'}}
          </span>
        </button>
      </div>
        <!--* LOGIN SSO -->
      <!-- <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button class="ms-Button ms-Dialog-action" type="button">Cancelar</button>
        <button 
          type="submit" 
          class="ms-Button ms-Button--primary"
          [disabled]="loginForm.invalid">
            <span class="ms-Button-label">Iniciar Sesión</span> 
        </button>
      </div> -->
    </form>
    
    <!-- <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{textoBotonProcesando}}
      </div>
    </div> -->
  </div>
</div>

<app-modal-notify #modalNotifyComponent></app-modal-notify>

